import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import { LandmineOpenModel } from '../model/LandmineOpenModel';

export type LandmineOpenCreate = Omit<LandmineOpenModel, 'id'>;

export class LandmineOpensController extends AuthenticatedController {
  static postLandmineOpen(
    entity: LandmineOpenCreate,
  ): Promise<{ entity: LandmineOpenModel }> {
    return super.post(APIRoutes.LANDMINE_OPENS, entity);
  }

  static putLandmineOpen(
    id: number,
    billingOpened: boolean,
  ): Promise<{ entity: LandmineOpenModel }> {
    return super.put(`${APIRoutes.LANDMINE_OPENS}/${id}`, { billingOpened });
  }
}
